import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { imageCacheService } from './services/imageCacheService';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for caching
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('Service worker registered successfully. Content cached for offline use.');
  },
  onUpdate: () => {
    console.log('New content available. Please refresh to update.');
  }
});

// Clear expired image cache on startup
imageCacheService.clearExpiredCache();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();